import React, { FC, useEffect, useMemo, useState, useCallback } from 'react';
import styles from './Filters.module.less';
import { Button, Checkbox, Divider, Input, Space, Spin } from 'antd';
import { SearchQuery, useSearchContext } from '../../SearchContext';
import { ConnectionApi } from '../../../../connection/ApplicationContext';
import _ from 'lodash';
import { useConnection } from '../../../../connection/Application';
import { FilterTitle } from './FilterTitle';

type Props = {
  value?: string[];
  onChange?: (value?: string[]) => void;
  onCancel?: () => void;
  getQuery: (value?: string[]) => SearchQuery;
};

const searchRecruiters = _.debounce(
  (
    connection: ConnectionApi,
    search: string,
    callback: (data: { value: string; label: string }[]) => void,
    loading: (state: boolean) => void,
  ) => {
    if (search === '') {
      return;
    }
    loading(true);
    connection
      .get('autocomplete/recruiter/all', { search, activity: 'active' })
      .then((res) => callback(res.masterdata))
      .finally(() => loading(false));
  },
  300,
);

export const CompanyFilter: FC<Props> = (props) => {
  const { onChange } = props;
  const [searchText, setSearchText] = useState<string>();
  const ctx = useSearchContext();
  const [value, setValue] = useState<string[] | undefined>(props.value);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [recruiters, setRecruiters] = useState<{ value: string; label: string }[]>([]);
  const connection = useConnection();
  const handleRecruiters = useCallback(
    (rec: { value: string; label: string }[]) => {
      const recruiter = rec.map((v) => ({ id: v.value, name: v.label }));
      console.log('RECRRRRRR', rec);
      console.log('RECRRRRRTTTTR', recruiter);
      setRecruiters(rec);
      ctx.setSelectedCompanies(recruiter ?? []);
    },
    [ctx],
  );

  useEffect(() => {
    searchRecruiters(connection, searchText ?? '', handleRecruiters, setSearchLoading);
  }, [connection, handleRecruiters, searchText]);

  const allData = useMemo(() => {
    const recruiterData = ctx.results?.aggs?.company;
    if (!recruiterData) {
      return [];
    }

    return Object.entries(recruiterData)
      .map((e) => ({
        label: `${e[0].split(':::')[1]} (${e[1]})`,
        value: e[0].split(':::')[0],
      }))
      .sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1));
  }, [ctx.results?.aggs?.company]);

  const dataToShow = useMemo(() => {
    if ((searchText ?? '') === '') {
      return allData.filter((s) => (props.value ? props.value?.indexOf(s.value) === -1 : true));
    }
    return allData.filter((s) =>
      searchText ? s.label.toLowerCase().indexOf(searchText?.toLowerCase()) !== -1 : true,
    );
  }, [allData, props.value, searchText]);
  //
  const staticDataToShow = useMemo(() => {
    return allData.filter(
      (s) => props.value && props.value?.indexOf(s.value) !== -1 && (searchText ?? '') === '',
    );
  }, [allData, props.value, searchText]);

  // useEffect(() => {
  //   if (value === props.value) {
  //     return;
  //   }
  //   const q = getQuery(value);
  //   setLoading(true);
  //   ctx
  //     .getCount(q)
  //     .then(setCount)
  //     .finally(() => setLoading(false));
  // }, [ctx, getQuery, props.value, value]);

  return (
    <Space size={16} direction="vertical" className={styles.filterArea}>
      <FilterTitle
        id={'company-filter'}
        title={'Company'}
        onApply={() => onChange?.(value && value.length > 0 ? value : undefined)}
        onCancel={props.onCancel}
      />
      <Input
        placeholder={'Search'}
        allowClear
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
      />
      <div className={styles.filterAreaSearch}>
        <Space direction="vertical">
          <Checkbox.Group onChange={((e: string[]) => setValue(e)) as any} value={value}>
            <Spin spinning={searchLoading}>
              <Space direction="vertical" className={styles.filterAreaSpace}>
                {(searchText ?? '') !== '' &&
                  recruiters.map((val) => (
                    <Checkbox key={val.value} value={val.value}>
                      {val.label}
                    </Checkbox>
                  ))}
                {(searchText ?? '') === '' && staticDataToShow.length > 0 && (
                  <>
                    {staticDataToShow.map((val) => (
                      <Checkbox key={val.value} value={val.value}>
                        {val.label}
                      </Checkbox>
                    ))}
                    <Divider style={{ margin: 0 }} />
                  </>
                )}
                {(searchText ?? '') === '' &&
                  dataToShow.map((val) => (
                    <Checkbox key={val.value} value={val.value}>
                      {val.label}
                    </Checkbox>
                  ))}
              </Space>
            </Spin>
          </Checkbox.Group>
        </Space>
      </div>
      <Button
        className={styles.applyButton}
        type={'primary'}
        size={'small'}
        onClick={() => {
          const companies =
            value && value.length > 0
              ? [
                  // Include companies from recruiters (search results)
                  ...recruiters
                    .filter((recruiter) => value.includes(recruiter.value))
                    .map((v) => ({ id: v.value, name: v.label })),
                  // Include companies from allData (static list)
                  ...allData
                    .filter(
                      (item) =>
                        value.includes(item.value) &&
                        !recruiters.some((r) => r.value === item.value),
                    )
                    .map((v) => ({ id: v.value, name: v.label.split(' (')[0] })),
                ]
              : [];

          console.log('RRRRRRRRRRRRRRRRRRRRRRRR', recruiters);
          console.log('Companiiiiiii', companies);
          ctx.setSelectedCompanies(companies ?? []);
          onChange?.(value && value.length > 0 ? value : undefined);
        }}>
        Apply
      </Button>
    </Space>
  );
};
